module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/图片4.a5696b63.png";